import { Plus, X } from 'lucide-react'
import ColumnInput from './ColumnInput'
import './editors.css'

const EMPTY_PAIR = { left: '', right: '' }

function parseValue(raw) {
  if (!raw) return []
  try {
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

function KeyPairsEditor({
  value,
  onChange,
  disabled,
  leftLabel = 'Left Column',
  rightLabel = 'Right Column',
  columns,
  rightColumns,
}) {
  const pairs = parseValue(value)

  const emit = (next) => onChange(JSON.stringify(next))

  const updatePair = (idx, key, val) => {
    const updated = [...pairs]
    updated[idx] = { ...updated[idx], [key]: val }
    emit(updated)
  }

  const addPair = () => {
    emit([...pairs, { ...EMPTY_PAIR }])
  }

  const removePair = (idx) => {
    emit(pairs.filter((_, i) => i !== idx))
  }

  return (
    <div>
      {pairs.map((pair, idx) => (
        <div key={idx} className="editor-row">
          <ColumnInput
            columns={columns}
            value={pair.left}
            onChange={(val) => updatePair(idx, 'left', val)}
            placeholder={leftLabel}
            disabled={disabled}
          />
          <span className="editor-equals">=</span>
          <ColumnInput
            columns={rightColumns || columns}
            value={pair.right}
            onChange={(val) => updatePair(idx, 'right', val)}
            placeholder={rightLabel}
            disabled={disabled}
          />
          <button
            className="editor-remove-btn"
            onClick={() => removePair(idx)}
            disabled={disabled}
            title="Remove key pair"
          >
            <X size={12} />
          </button>
        </div>
      ))}

      {pairs.length === 0 && (
        <div className="editor-empty">No key pairs defined</div>
      )}

      <button
        className="editor-add-btn"
        onClick={addPair}
        disabled={disabled}
      >
        <Plus size={12} />
        Add Key Pair
      </button>
    </div>
  )
}

export default KeyPairsEditor
